// extracted by mini-css-extract-plugin
export default {"checkoutMoneyback":"styles_checkoutMoneyback__utYNc","checkoutMoneybackBox":"styles_checkoutMoneybackBox__D8o5v","seal":"styles_seal__SBzmZ"};